import formValidators from '../../form-validators';
import { useForm } from '../../hooks/useForm.hook';
import { useResourceInput } from '../../hooks/useResourceInput';
import clarificationsService from '../../services/api/clarifications.service';
import Datepicker from '../forms/Datepicker';
import TextField from '../forms/TextField';

const DossierClarificationDetails = ({ dossierId, id, date, startTime, endTime, write, onUpdated }) => {
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError } = useForm({
    id,
    date,
    startTime,
    endTime
  });
  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      clarificationsService.update(
        dossierId,
        data.id,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field, data.id);
            options.onSuccess();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options.onError(message);
          }
        }
      );
    },
    validators: {
      date: formValidators.date.dateTextField,
      startTime: formValidators.time.hourMinuteField,
      endTime: formValidators.time.hourMinuteField
    },
    onCancel: reset
  };

  return (
    <div className="spo-o-dossier-clarification-details">
      <div className="row u-margin-bottom-xl">
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs">
          <Datepicker
            label="Datum vraagverheldering"
            {...useResourceInput('date', resource, '', { ignoreTouched: true })}
            readOnly={!write}
            required
          />
        </div>
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs">
          <TextField
            label="Starttijd"
            mask="99:99"
            {...useResourceInput('startTime', resource)}
            readOnly={!write}
            required
          />
        </div>
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs before-agenda">
          <TextField
            label="Eindtijd"
            mask="99:99"
            {...useResourceInput('endTime', resource)}
            readOnly={!write}
            required
          />
        </div>
        {/* <div className="col-xs-12 col-md-6 u-margin-bottom-xs agenda">
          <Button iconRight="ai-calendar" outline>
            Toevoegen aan agenda
          </Button>
        </div> */}
      </div>
    </div>
  );
};

export default DossierClarificationDetails;
